import { IAppConfig } from '../type';

export function validateConfig(
    config: IAppConfig,
    log: (level: 'error' | 'debug' | 'warn' | 'message', message: string) => void
) {
    function logError(msg: string) {
        console.error(msg);
        try {
            log('error', msg);
        } catch (e) {
            console.error(e);
        }
    }

    function checkEndpoint(endpoint: 'createOffer' | 'updateOffer') {
        if (!config.endpoints[endpoint] || !config.endpoints[endpoint].url)
            logError(`missing ${endpoint} endpoint in config`);
    }

    if (!config) return logError('missing config');

    if (!config.appId) logError('missing appId in config');
    if (!config.logLevel) logError('missing logLevel in config');
    if (config.primaryType !== 'accident' && config.primaryType !== 'contents')
        logError('invalid primaryType in config');

    if (!config.endpoints) return logError('missing endpoints in config');
    if (!config.endpoints.resources) logError('missing resource endpoint in config');
    if (!config.endpoints.getReceipt) logError('missing getReceipt endpoint in config');
    if (!config.endpoints.submitOffer) logError('missing submitOffer endpoint in config');
    if (!config.endpoints.log) logError('missing log endpoint in config');
    checkEndpoint('createOffer');
    checkEndpoint('updateOffer');
}
